import type { ActionType, ActionHandler } from './types'

// Phase 1 handlers
import { handleReceiveWound } from './handlers/receiveWound'
import { handleTreatWound } from './handlers/treatWound'
import { handleHealWound } from './handlers/healWound'
import { handleAddFatigue, handleRemoveFatigue } from './handlers/fatigue'
import { handleAdjustFunds } from './handlers/adjustFunds'
import { handleEquipArmour, handleUnequipArmour, handleEquipWeapon, handleUnequipWeapon, handleAbandonWeapon, handleAbandonArmour, handleDrawWeaponToHand, handleReleaseWeaponFromHand, handleGripWeaponTwoHanded, handleDropWeaponFromHand } from './handlers/equipToggle'

// Phase 2 handlers
import { handleAdvanceSkill } from './handlers/advanceSkill'
import { handleOpenSkill } from './handlers/openSkill'
import { handleApplyCondition, handleRemoveCondition } from './handlers/conditions'
import { handleAddBloodloss, handleReduceBloodloss } from './handlers/bloodloss'

// Phase 3 handlers
import { handleAcquireEquipment, handleDropEquipment, handleMoveEquipment, handleUseItem, handlePutInContainer, handleRemoveFromContainer } from './handlers/equipment'

// Phase 4 handlers
import { handleInfectWound } from './handlers/infectWound'
import { handleBiographyEntry } from './handlers/biography'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handlers: Partial<Record<ActionType, ActionHandler<any>>> = {
  RECEIVE_WOUND: handleReceiveWound,
  TREAT_WOUND: handleTreatWound,
  HEAL_WOUND: handleHealWound,
  ADD_FATIGUE: handleAddFatigue,
  REMOVE_FATIGUE: handleRemoveFatigue,
  ADJUST_FUNDS: handleAdjustFunds,
  EQUIP_ARMOUR: handleEquipArmour,
  UNEQUIP_ARMOUR: handleUnequipArmour,
  EQUIP_WEAPON: handleEquipWeapon,
  UNEQUIP_WEAPON: handleUnequipWeapon,
  ABANDON_WEAPON: handleAbandonWeapon,
  ABANDON_ARMOUR: handleAbandonArmour,
  DRAW_WEAPON_TO_HAND: handleDrawWeaponToHand,
  RELEASE_WEAPON_FROM_HAND: handleReleaseWeaponFromHand,
  DROP_WEAPON_FROM_HAND: handleDropWeaponFromHand,
  GRIP_WEAPON_TWO_HANDED: handleGripWeaponTwoHanded,
  ADVANCE_SKILL: handleAdvanceSkill,
  OPEN_SKILL: handleOpenSkill,
  APPLY_CONDITION: handleApplyCondition,
  REMOVE_CONDITION: handleRemoveCondition,
  ADD_BLOODLOSS: handleAddBloodloss,
  REDUCE_BLOODLOSS: handleReduceBloodloss,
  ACQUIRE_EQUIPMENT: handleAcquireEquipment,
  DROP_EQUIPMENT: handleDropEquipment,
  MOVE_EQUIPMENT: handleMoveEquipment,
  USE_ITEM: handleUseItem,
  PUT_IN_CONTAINER: handlePutInContainer,
  REMOVE_FROM_CONTAINER: handleRemoveFromContainer,
  INFECT_WOUND: handleInfectWound,
  BIOGRAPHY_ENTRY: handleBiographyEntry,
}

export function getHandler<T extends ActionType>(type: T): ActionHandler<T> {
  const handler = handlers[type]
  if (!handler) throw new Error(`No handler registered for action type: ${type}`)
  return handler as ActionHandler<T>
}
